import { createRef } from 'react';
var createUserRef = function () { return createRef(); };
export default createUserRef;
//# sourceMappingURL=createUserRef.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/auth/dist/functions/createUserRef.js
// module id = 110
// module chunks = 1